import { CloseIconThin } from "assets/svg";
import { css, styled } from "styled-components";

import { elementSpacingMixin } from "../styles";
import { BadgeProps } from "./types";

const badgeColorsMixin = css<BadgeProps>`
  ${({ $variant }) => {
    switch ($variant) {
      case "blue":
        return css`
          background-color: ${({ theme }) => theme.colors.colorsNew.blue.light_blue};
          span {
            color: ${({ theme }) => theme.colors.colorsNew.blue.blue};
          }

          svg path {
            fill: ${({ theme }) => theme.colors.colorsNew.blue.blue};
          }

          &::before {
            background-color: ${({ theme }) => theme.colors.colorsNew.blue.blue};
          }
        `;
      case "orange":
        return css`
          background-color: ${({ theme }) => theme.colors.colorsNew.primary["100"]};
          span {
            color: ${({ theme }) => theme.colors.colorsNew.primary["500_main"]};
          }

          svg path {
            fill: ${({ theme }) => theme.colors.colorsNew.primary["500_main"]};
          }

          &::before {
            background-color: ${({ theme }) => theme.colors.colorsNew.primary["500_main"]};
          }
        `;
      case "yellow":
        return css`
          background-color: ${({ theme }) => theme.colors.colorsNew.warning["100"]};
          span {
            color: ${({ theme }) => theme.colors.colorsNew.warning["600"]};
          }

          svg path {
            fill: ${({ theme }) => theme.colors.colorsNew.warning["600"]};
          }

          &::before {
            background-color: ${({ theme }) => theme.colors.colorsNew.warning["600"]};
          }
        `;
      case "red":
        return css`
          background-color: ${({ theme }) => theme.colors.colorsNew.error["100"]};
          span {
            color: ${({ theme }) => theme.colors.colorsNew.error["500_main"]};
          }

          svg path {
            fill: ${({ theme }) => theme.colors.colorsNew.error["500_main"]};
          }

          &::before {
            background-color: ${({ theme }) => theme.colors.colorsNew.error["500_main"]};
          }
        `;
      case "green":
        return css`
          background-color: ${({ theme }) => theme.colors.colorsNew.success["100"]};
          span {
            color: ${({ theme }) => theme.colors.colorsNew.success["600"]};
          }

          svg path {
            fill: ${({ theme }) => theme.colors.colorsNew.success["600"]};
          }

          &::before {
            background-color: ${({ theme }) => theme.colors.colorsNew.success["600"]};
          }
        `;
      case "gray":
        return css`
          background-color: ${({ theme }) => theme.colors.colorsNew.gray["100"]};
          span {
            color: ${({ theme }) => theme.colors.colorsNew.gray["500_main"]};
          }

          svg path {
            fill: ${({ theme }) => theme.colors.colorsNew.gray["500_main"]};
          }

          &::before {
            background-color: ${({ theme }) => theme.colors.colorsNew.gray["500_main"]};
          }
        `;
    }
  }}
`;

const badgeDotMixin = css<BadgeProps>`
  ${({ $showDot }) => {
    if ($showDot) {
      return css`
        position: relative;

        &::before {
          content: "";
          width: 6px;
          height: 6px;
          border-radius: 50%;
        }
      `;
    }
  }}
`;

export const BadgeBase = styled.div<BadgeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 16px;
  padding: 6px 8px;
  ${badgeColorsMixin};
  ${badgeDotMixin};
  ${elementSpacingMixin}
`;

export const StyledCloseIconThin = styled(CloseIconThin)`
  cursor: pointer;
  width: 14px;
  height: 14px;
  path {
    width: 14px;
    height: 14px;
  }
`;
